import kullaniciModel from '@/states/kullaniciModel';
import mutabakatModel from '@/states/mutabakatModel';
import { UserDto } from '@emutabakat-types/anaveri';
import userManager from '@/oidc/userManager';

export const logOut = () => {
  kullaniciModel.setCurrentUser({} as UserDto);
  userManager.removeUser().then(() => {
    userManager.signoutRedirect();
  });
};

export const logIn = () => {
  kullaniciModel
    .getCurrentUser()
    .then(response => {
      kullaniciModel.setCurrentUser(response.currentUser);
      mutabakatModel.setOnaydakiMusteriSaticiAdet(
        response.currentUser && response.currentUser.musteriSaticiOnayAdedi
      );
      mutabakatModel.setOnaydakiBaBsAdet(
        response.currentUser && response.currentUser.baBsOnayAdedi
      );
    })
    .catch(() => {
      logOut();
    });
};
